<template>
    <div class="main mt15 detail">
        <div class="banner" @click="toBuy">
            <img src="../../images/gzTab.jpg" alt="" ref="info">
            <div class="banner-container">
                <!-- <div class="banner-container-title">定制-建工雇主责任险按项目方案</div>
                <div class="banner-container-case">— 老板事业的护身符 —</div>
                <div class="banner-container-sub">
                    <Icon type="md-checkmark-circle" color="#318af0" /> <span>雇主意外</span>
                    <Icon type="md-checkmark-circle" color="#318af0" /> <span>职业病</span>
                    <Icon type="md-checkmark-circle" color="#318af0" /> <span>误工津贴</span>
                </div>
                <div class="banner-container-btn">
                    <a class="btn" @click="toBuy">立即购买</a>
                </div> -->
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <!-- <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane> -->
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
                <div class="tabs-container-form" v-show="fixed">
                    <Button type="primary" @click="toBuy">立即购买</Button>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <div style="color: red;">咨询电话：187 6642 6120</div>
                <div class="detail-main-text">
                    本方案为建筑工团体雇主责任险，保障所在项目施工现场发生的意外伤害事故引起的雇主赔偿责任。
                </div>
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th rowspan="2" width="50px">类型</th>
                                <th rowspan="2">保障额度</th>
                                <th rowspan="2">总包费率</th>
                                <th rowspan="2">劳务分包费率</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td rowspan="3" width="200" class="hoverDisabled">土建项目/路政项目</td>
                                <td>50万死亡伤残+5万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.09%</td>
                                <td>工程造价*费率0.27%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>80万死亡伤残+8万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.13%</td>
                                <td>工程造价*费率0.4%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>100万死亡伤残+10万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.16%</td>
                                <td>工程造价*费率0.48%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td rowspan="3" width="100" class="hoverDisabled">工程装修类</td>
                                <td>50万死亡伤残+5万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.09%</td>
                                <td>工程造价*费率0.27%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>80万死亡伤残+8万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.13%</td>
                                <td>工程造价*费率0.4%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>100万死亡伤残+10万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.16%</td>
                                <td>工程造价*费率0.48%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td rowspan="3" width="100" class="hoverDisabled">消防、机电类</td>
                                <td>50万死亡伤残+5万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.13%</td>
                                <td>工程造价*费率0.39%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>80万死亡伤残+8万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.20%</td>
                                <td>工程造价*费率0.6%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>100万死亡伤残+10万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.30%</td>
                                <td>工程造价*费率0.9%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td rowspan="3" width="100" class="hoverDisabled">外墙保温类</td>
                                <td>50万死亡伤残+5万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.22%</td>
                                <td>工程造价*费率0.66%</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>80万死亡伤残+8万医疗+100元/天误工补贴</td>
                                <td>工程造价*费率0.3%</td>
                                <td>工程造价*费率0.9%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="detail allDet detail-main-text">
            <b>说明：</b>
            <p>
                1、医疗费：社保目录内用药，免赔100元后按100%赔付；
            </p>
            <p>
                2、误工津贴：免赔5天，每次最高90天，累计不超180天；
            </p>
            <p>
                3、伤残比例：1%，4%，10%，15%，25%，45%，55%，65%，80%，100%；（外墙类。客户可选择十级5%，保费上浮15%）
                <span style="padding-left: 100px;">5%，7%，15%，20%，30%，40%，60%，70%，80%，100%（土建装修消防机电）</span>
                
            </p>
            <p>
                4、保险费：合同造价*费率 
            </p>
            <p>
                5、承保公司：共保体（阳光主承、太平洋、平安）
            </p>
            <p>
                6、最低收费：50万内3000元；80万4000元；100万的 5000元
            </p>
            <b>特别约定：</b>
            <p>
                1、本保单不承保猝死、疾病、食物中毒、中暑责任。
            </p>
            <p>
                2、保险事故发生后，请第一时间拨打保险公司24小时服务电话进行报案,电话95510。重大人员伤亡案件须保留现场并第一时间通知保险人，若因伤员救治、抢险等原因需移除现场的，应对现场进行拍照、录像等，以保留现场原貌。若通知不及时，造成保险人无法收集第一现场资料，无法确定保险责任的，保险人不承担赔偿责任。
            </p>
            <p>
                3、本保单投保区域范围为为施工合同列明的施工区域，超过上述区域范围保险人不承担险责任。施工区域以承保时投保人提供的施工合同和（或）施工图样说明为准；
            </p>
            <p>
                4、保险期间以施工工期为准。提前竣工的,保险责任自行终止。工程因故延长工期或停工,需书面通知保险人并办理保险期间顺延手续。保险合同期间届满，工程仍未竣工的，需提前三个工作日办理保险期间顺延手续；
            </p>
            <p>
                5、本保单每次事故每人医疗费用，在被保险人实际支付的与当次事故相关且符合国家基本医疗保险报销标准的医疗费用基础上，扣除绝对免额人民币100元后按照100%的比例在相应责任限额内给予赔付；
            </p>
            <p>
                6、附加误工补助赔偿保险条款，误工补助标准为每人100元/天，每次事故每人赔付不超过90天，全年累计每人最高不超过180天，每次绝对免赔5天；
            </p>
            <p>
                7、被保险人从事高空作业或楼宇外墙作业时，必须按照相关行业安全管理规定（包括但不限于必须佩带安全绳、安全带或者安装防护网架等安全设施设备）开展作业活动，否则本保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。（根据GB/T3608《高处作业分级》国家标准的规定，凡在有可能坠落的高处进行施工作业，当坠落高度距离基准面在2米及2米以上时，该项作业即称为高空（高处）作业。）因高空作业出险理赔时免提供高空作业证。
            </p>
            <p>
                8、同一项目地址内若有多个合同项目，所有项目应全部投保，否则，保险人有权拒赔或比例赔付。投保金额小于工程合同预算金额，保险人按投保工程造价与实际工程造价之比进行比例赔付。
            </p>
            <p>
                9、本保单非实名制投保，不计投保比例。
            </p>
            <p>
                10、对于保险期限内，2人以下（含2人）死亡伤残免安监；2人以上提供安监证明；
            </p>
            <p>
                11、本保单约定伤残比例限额：十级伤残采用十级5%，九级7%，八级15%，七级20%，六级30%，五级40%，四级60%，三级70%，二级80%，一级100%；（此项为土建装修消防机电的伤残比例限额，若为外墙项目，则十级伤残采用1%的比例，如果想升级到十级是5%的比例，保费需上浮15%）
            </p>
            <p>
                12、本保单由主承保人阳光财产股份有限公司青岛分公司（共保比例20%）和从共承保人中国太平洋财产保险股份有限公司青岛分公司（共保比例40%）、中国平安财产保险股份有限公司青岛市分公司（共保比例40%）共同承保。
            </p>
            <p>
                13、无其他特别约定。
            </p>
        </div>

        <div class="detail allDet detail-main-text" ref="claim">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
            <!-- <div class="step-contain">
                <div class="step-item">
                    <p>1、拨打报案电话</p>
                    <div>请立即拨打报案电话18766426120进行报案
                        ，详细说明出险情况。被保险人应在48小时
                        内及时报案。</div>
                </div>
                <div class="step-item">
                    <p>2、提交索赔材料</p>
                    <p>报案后我们会告知您所需的材料，
                        请按照要求待治疗结束后提供资料。</p>
                </div>
                <div class="step-item">
                    <p>3、领取赔款</p>
                    <p>资料收到后，保险公司核定损失，
                        确定赔偿金额，按照约定赔付方式
                        支付赔款。</p>
                </div>
            </div> -->
            <b style="margin-top: 20px;">理赔案例：</b>
            <p>案例1：</p>
            <p>出险：2023.4.26上午11点左右青岛张龙建设有限公司张作启在青岛市城阳区惜福镇干活的时候，不小心踩空了，扭伤脚，骨折。</p>
            <p>报案：受伤后，公司对接人张经理及时报案。</p>
            <p>提交资料：2023.7.6日收到师傅治疗结束后邮寄的全部资料。</p>
            <p>理赔： 2023.7.10日已赔付完毕，合计赔付33454.68元。</p>
            <p style="margin-top: 20px;">案例2：</p>
            <p>出险：2022.08.11日烟台市金圣建筑劳务有限公司刘宗悦干活的时候被手提切割机切到手。</p>
            <p>报案：受伤后，公司对接人刘总及时报案。</p>
            <p>提交资料：2023.4.6日收到师傅治疗结束后准备的资料。</p>
            <p>理赔： 2023.4.12日赔付完毕，合计赔付30100.79元。</p>
            <p style="margin-top: 20px;">案例3：</p>
            <p>出险：2023.5.9日上午8点半左右，七彩建设发展有限公司孙来超在福建省莆田市仙游县鲤城街道工作的时候摔伤到右侧肋骨。</p>
            <p>报案：受伤后，公司对接人卢经理及时报案。</p>
            <p>提交资料：2023.7.10日师傅资料已齐全。</p>
            <p>理赔：2023.7.16日赔付完毕，合计赔付19185元。 </p>

        </div>
        <TrackNotice />
    </div>
</template>
<script>
    import TrackNotice from '@/components/common/TrackNotice.vue';
    import track from "@/mixin/track";
    export default {
        components:{ TrackNotice },
        mixins:[ track ],
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted() {
            this.track_is_new = true;
            this.$nextTick(()=>{
                window.addEventListener("scroll", this.handleScroll);
                this.trackInit(); 
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                this.stopRecord({
				    is_new: true
                }).then(()=>{
                    let url = '/haierProduct.html#/customized-employer-liability/fillin';
                    if (this.renewId) url += `/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
                    else url += `?productCode=QYTTGZZRXPCNEW`
                    location.href = url
                })
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/Index.vue